import { TYPE_STRING } from './input-types';

export const id = 'buyerName';
export const apiKey = 'BuyerName';
export const type = TYPE_STRING;

export const buyerName = {
  id,
  apiKey,
  type,
};
